import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '@/features/account';

export const Route = createFileRoute('/_auth/me/notifications')({
  component: NotificationsPage,
});
